import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, ActivatedRouteSnapshot } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private breadcrumbs = new BehaviorSubject<MenuItem[]>([]);
  private pageTitle = new BehaviorSubject<string>('');

  breadcrumbs$ = this.breadcrumbs.asObservable();
  pageTitle$ = this.pageTitle.asObservable();

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const root = this.router.routerState.snapshot.root;
      const breadcrumbs: MenuItem[] = [];
      this.addBreadcrumb(root, [], breadcrumbs);

      const home: MenuItem = { icon: 'pi pi-home', routerLink: '/' };
      this.breadcrumbs.next([home, ...breadcrumbs]);

      // Set page title from the deepest route's 'title' data property
      let currentRoute = this.activatedRoute.root;
      let title = '';
      while (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      }
      title = currentRoute.snapshot.data['title'] || (breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1].label : 'Inicio');
      this.pageTitle.next(title);
    });
  }

  private addBreadcrumb(route: ActivatedRouteSnapshot | null, parentUrl: string[], breadcrumbs: MenuItem[]) {
    if (route) {
      const routeUrl = parentUrl.concat(route.url.map(url => url.path));
      if (route.data['breadcrumb']) {
        const breadcrumb = {
          label: route.data['breadcrumb'],
          routerLink: '/' + routeUrl.join('/')
        };
        breadcrumbs.push(breadcrumb);
      }
      this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
    }
  }
}
